module.exports = __webpack_public_path__ + "static/media/safetyplan-blue.26550ee4.svg";